// extracted by mini-css-extract-plugin
export default {"nav-list":"NavList_nav-list__Sd+Wi"};